<template>
  <div>
    <section class="section">
      <div class="container">
        <div class="row">
          <div class="col product-list">
            <div class="row">
              <div class="col-12">
                <h2>
                  Catalogues
                </h2>
              </div>
            </div>
            <div class="row">
              <div class="col-12 mt-3">
                <div class="form-group">
                  <div class="input-group products-search-form-group mt-3 mt-sm-0">
                    <div class="input-group-prepend">
                      <span class="input-group-text">
                        <i class="ni ni-zoom-split-in"></i>
                      </span>
                    </div>
                    <input
                      class="form-control"
                      placeholder="Search"
                      type="text"
                      v-model="searchInput">
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div
                v-for="catalog in searchedCatalogs"
                class="col-12"
                :key="catalog.name">
                <card class="mt-3">
                  <div class="row">
                    <div class="col-sm-3">
                      <img :src="catalog.imageUrl" width="100%">
                    </div>
                    <div class="col-sm-9 mt-5 mt-sm-0">
                      <h5>
                        {{ catalog.name }}
                      </h5>
                      <p>
                        {{ catalog.description }}
                      </p>
                      <a
                        class="btn btn-info"
                        :href="catalog.pdfUrl"
                        target="_blank">
                        <span class="btn-inner--icon">
                          <i class="fa fa-file mr-2"></i>
                        </span>
                        <span class="nav-link-inner--text">
                          View PDF
                        </span>
                      </a>
                    </div>
                  </div>
                </card>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import _ from 'lodash'
import Fuse from 'fuse.js'

export default {
  data() {
    return {
      searchInput: '',
    }
  },
  methods: mapActions(['fetchCatalogs']),
  computed: {
    ...mapGetters(['catalogsSorted']),
    searchedCatalogs() {
      const { searchInput, catalogsSorted } = this
      const fuse = new Fuse(catalogsSorted, {
        shouldSort: true,
        threshold: 0.1,
        location: 0,
        distance: 100,
        maxPatternLength: 32,
        minMatchCharLength: 1,
        keys: ['name', 'description'],
      })
      return searchInput === '' ? catalogsSorted : fuse.search(searchInput)
    },
  },
  mounted() {
    this.fetchCatalogs()
  }
}
</script>
<style>
.team-card-body {
  box-sizing: border-box;
  padding: 2em;
}
</style>
